export default __webpack_public_path__ + "static/media/share-preview-facebook.dc7b58a7.png";